import React from "react";
import { IconUser } from "@tabler/icons-react";
import aiChatIcon from "../../images/lxw-ai-icon.png";

export const userSourceName = "You";
export const aiSourceName = "LexWorkplace AI";

export const formatTimestamp = (ts) => {
	if (!ts) return null;
	return new Date(ts).toLocaleString("en-US", {
		month: "short",
		day: "numeric",
		hour: "numeric",
		minute: "2-digit",
	});
};

const ConversationIcon = ({ sourceName }) => {
	if (sourceName === userSourceName) {
		return (
			<IconUser
				size={36}
				color="var(--lw-ai-blue)"
				style={{ verticalAlign: "middle" }}
			/>
		);
	}
	return (
		<div className="ai-chat-logo">
			<img src={aiChatIcon} alt="AI" draggable={false} />
		</div>
	);
};

export default ConversationIcon;
